module.exports = function() {
  return new Worker(__webpack_public_path__ + "e0dd5a4742976c954c3d.worker.js");
};